@import (reference) '../../../../../../constants/spacing.module.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.shipping-default-wrapper {
  display: flex;
  gap: @space-8;
  justify-content: space-between;
  align-items: center;
}

.shipping-default-save-button {
  min-width: 75px;
}

.shipping-default-save-success {
  display: flex;
  align-items: center;
  height: 30px;
  min-width: 75px;
}

.completed-icon {
  width: 16px;
  height: 16px;
  margin: @space-8;
  fill: var(--success--background-color--3);
}
